import { Admin } from '@scribe-sas/types/admin'
import ApiService from 'services/ApiService'

export default class SessionTransportLayer {
  public async getSession() {
    return ApiService.get<Admin.SessionsIndex.ResponseBody>('/sessions')
  }

  public async loginWithPassword(
    body: Admin.SessionsCreate.RequestBody['admin_user'],
  ) {
    return ApiService.post<
      Admin.SessionsCreate.RequestBody,
      Admin.SessionsCreate.ResponseBody,
      void
    >('/sessions', {
      admin_user: body,
    })
  }
}
